import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { subContainerTypesApi } from './sub-container-types.api';
import type { SubContainerTypesListParams } from '../sub-container-types.types';

export const subContainerTypeKeys = {
  all: ['sub-container-types'] as const,
  lists: () => [...subContainerTypeKeys.all, 'list'] as const,
  list: (filters: SubContainerTypesListParams) =>
    [...subContainerTypeKeys.lists(), filters] as const,
  details: () => [...subContainerTypeKeys.all, 'detail'] as const,
  detail: (id: number) => [...subContainerTypeKeys.details(), id] as const
};

export const subContainerTypeQueries = {
  list: (filters: SubContainerTypesListParams = {}) =>
    queryOptions({
      queryKey: subContainerTypeKeys.list(filters),
      queryFn: () => subContainerTypesApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: subContainerTypeKeys.detail(id),
      queryFn: () => subContainerTypesApi.getById(id),
      enabled: id > 0
    })
};
